/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ConfigurazioneFormCittadinoDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetConfigurazioneFormCittadinoRequestParams {
    slug: string;
    idTp: string;
    anteprima?: boolean;
}


export interface CittadinoConfigurazioneFormBandoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Restituisce la configurazione del form cittadino del bando in formato legacy-shape JSON con i $dynamic placeholder gia\&#39; espansi dai satelliti. Il path variable {idTp} accetta sia l\&#39;UUID sia il codice del bando (risolto entro il comune).
     * Con ?anteprima&#x3D;true il gate di visibilita\&#39; rilassa SOLO lo stato del bando (anche IN_ATTESA), mantenendo il vincolo visualizzazione&#x3D;PUBBLICA e l\&#39;appartenenza al comune: consente l\&#39;anteprima del form di un bando in bozza. Nessuna autenticazione richiesta (comportamento identico per anonimi e loggati). La sottomissione resta comunque bloccata per i bandi non ancora sottomettibili.
     * @endpoint get /api/v1/cittadino/comuni/{slug}/tipi-pratica/{idTp}/configurazione-form
* @param requestParameters
     */
    getConfigurazioneFormCittadino(requestParameters: GetConfigurazioneFormCittadinoRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormCittadinoDTO>;

}
